module.exports = __webpack_public_path__ + "static/media/faq1.be72815f.svg";